<template>
  <div class="form-single-fragment">
    <el-form
      ref="form"
      :model="formData"
      class="full-width-input"
      :rules="rules"
      :label-width="formConfig.labelWidth + 'px'"
      :size="defaultFormItemSize"
      :label-position="formConfig.labelPosition"
      @submit.native.prevent
    >
      <el-row :gutter="formConfig.gutter" class="my-row">
        <template v-for="widget in formConfig.formWidgetList">
          <CustomTable
            :ref="widget.variableName"
            v-if="widget.widgetType === SysCustomWidgetType.Table"
            :key="widget.id"
            :widgetConfig="widget"
            :formType="formConfig.formType"
            :primaryColumnName="widget.primaryColumnName"
            :flowData="flowData"
            :isNew="true"
            :total.sync="total"
            :list.sync='list'
            :getTableQueryParams="getTableQueryParams"
            @operationClick="onTableOperationClick"
            @changeTotal="handleChangeTotal"
          />
          <CustomUpload
            :ref="widget.variableName"
            :key="widget.id"
            v-else-if="widget.widgetType === SysCustomWidgetType.Upload"
            :widgetConfig="widget"
            :flowData="flowData"
            :getDataId="getWidgetPrimaryColumnId"
            v-model="formData[getWidgetFieldName(widget)]"
          />
         <CustomWidget
            v-else
            :ref="widget.variableName"
            :key="widget.id"
            :widgetConfig="widget"
            :formConfig="formConfig"
            :getDropdownParams="getDropdownParams"
            v-model="formData[getWidgetFieldName(widget)]"
            :projectName="formData.data_233"
            :formData="formData"
            @change="changeProject"
            @changeAmount="handleSetAmount"
            @setFormData="handleSetFormData"
          >
            <template v-for="subWidget in widget.childWidgetList">
              <CustomTable
                :ref="subWidget.variableName"
                v-if="subWidget.widgetType === SysCustomWidgetType.Table" :key="subWidget.id"
                :widgetConfig="subWidget"
                :formType="formConfig.formType"
                :isNew="true"
                :getTableQueryParams="getTableQueryParams"
                @operationClick="onTableOperationClick"
                @changeTotal="handleChangeTotal"
              />
              <CustomUpload
                :ref="subWidget.variableName"
                :key="subWidget.id"
                v-else-if="subWidget.widgetType === SysCustomWidgetType.Upload"
                :widgetConfig="subWidget"
                :flowData="flowData"
                :getDataId="getWidgetPrimaryColumnId"
                v-model="formData[getWidgetFieldName(subWidget)]"
              />
              <CustomWidget
                v-else
                :ref="subWidget.variableName"
                :key="subWidget.id"
                :widgetConfig="subWidget"
                :formConfig="formConfig"
                :getDropdownParams="getDropdownParams"
                 @change="changeProject"
                :formData="formData"
                v-model="formData[getWidgetFieldName(subWidget)]"
              />
            </template>
          </CustomWidget>
        </template>
      </el-row>
      <fileModule :dataId="formData['data_43'] "/>
    </el-form>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {OnlineFormMixins} from './onlineFormMixins.js';
import CustomUpload from '@/views/onlineForm/components/customUpload.vue';
import CustomWidget from '@/views/onlineForm/components/customWidget.vue';
import CustomTable from '@/views/onlineForm/components/customTable.vue';
import {FlowEntryController} from '@/api/flowController.js';
import fileModule from './fileModule';
import {Contract} from '@/api/contract';
import {Ask} from '@/api/ask';
import { FlowOperationController } from '@/api/flowController.js';

export default {
  name: 'workflowForm',
  props: {
    readOnly: {
      type: [String, Boolean]
    },
    flowEntryName: {
      type: String
    }
  },
  inject: ['preview'],
  mixins: [OnlineFormMixins],
  components: {
    CustomWidget,
    CustomTable,
    CustomUpload,
    fileModule
  },
  data () {
    return {
      flowData: {},
      total:0,
      list:[],
      name:this.$route.query.processDefinitionKey,
      formId2:this.$route.query.formId
    }
  },

  beforeDestroy(){
    if (localStorage.getItem(this.name+'flag') && localStorage.getItem('flowForm') === 'undefined') {
      localStorage.setItem(this.name + 'list', JSON.stringify(this.list))
      localStorage.setItem(this.name, JSON.stringify(this.formData))
    }
  },
  methods: {
    handleChangeTotal(val){
      this.formData.data_50 = val.toFixed(2)
      this.handleSetAmount(this.formData.data_50 * 1 ,'data_53')
    },
    handleSetFormData (value, name) {
      this.formData[name] = value
    },
    getWidgetFieldName (widget) {
      if(widget.columnName === 'data_252'|| widget.columnName === 'data_233'|| widget.columnName === 'qj_date'){
        widget.type = 'select'
        widget.widgetType = 10
      }
      if(widget.columnName == 'data_14' || widget.columnName == 'data_15' && this.$route.query.processDefinitionKey == 'oaFlowData170'){
          widget.showName = ''
      }
      if (widget && widget.relation == null) {
        return (widget.column || {}).columnName;
      } else {
        return widget.relation.variableName + '__' + (widget.column || {}).columnName
      }
    },
    getDropdownParams (widget) {
      if (Array.isArray(widget.dictParamList)) {
        let params = {};
        for (let i = 0; i < widget.dictParamList.length; i++) {
          let dictParam = widget.dictParamList[i];
          if (dictParam.dictValue == null || dictParam.dictValueType == null) continue;
          params = this.getParamValueObj(dictParam.dictParamName, dictParam.dictValueType, dictParam.dictValue, params);
          if (params == null) return null;
        }

        return params;
      } else {
        return {};
      }
    },
    getTableQueryParams (widget) {
      return {};
    },
    onTableOperationClick (operation, row, widget) {
      this.handlerOperation(operation, row, widget);
    },
    setFormData (formData, oneToManyData, flowData) {
      this.flowData = flowData || {};
      localStorage.setItem('flowForm', this.$route.query.form)
      if(localStorage.getItem(this.$route.query.processDefinitionKey) && !this.$route.query.form){
        const flag = localStorage.getItem(this.$route.query.processDefinitionKey+'flag').split('-**')[1]
        if (!formData && flag) formData = JSON.parse(localStorage.getItem(this.$route.query.processDefinitionKey))
      }

      this.formData = {
        ...this.formData,
        ...formData
      }
      if (this.formConfig.formType === 10 && !this.readOnly && !this.formData['data_32']) {
        const userInfo = this.getUserInfo
        if (userInfo) {
          this.formData['data_32'] = userInfo.showName
          this.formData['data_42'] = dayjs().format('YYYY-MM-DD')
          this.formData['data_33'] = userInfo.deptName || '' // 部门
          this.formData['data_35'] = userInfo.deptPost && userInfo.deptPost.postShowName ? userInfo.deptPost.postShowName : '' // 职务
          this.formData['run_name'] = `${this.flowEntryName}流程（${dayjs().format('YYYY年MM月DD日 HH:mm')}）${userInfo.showName}`
          FlowEntryController.getFormNo(this).then(rs => {
            if (rs.success && !this.formData['data_43']) {
              this.formData['data_43'] = rs.data
            }
          })
        }
      }
      
      this.setOneToManyRelationData(oneToManyData);
    },
    setOneToManyRelationData (oneToManyRelationList) {
      if (oneToManyRelationList != null) {
        Object.keys(oneToManyRelationList).forEach(relationVariableName => {
          if (Array.isArray(this.tableWidgetList)) {
            for (let i = 0; i < this.tableWidgetList.length; i++) {
              let tableWidget = this.tableWidgetList[i];
              if (tableWidget.relation.variableName === relationVariableName) {
                let temp = this.$refs[tableWidget.variableName];
                let tableImpl = Array.isArray(temp) ? temp[0] : temp;
                if (tableImpl) {
                  tableImpl.getTableWidget().dataList = oneToManyRelationList[relationVariableName];
                }
                break;
              }
            }
          }
        });
      }
    },
    getVariableData (variableList) {
      let variableData;
      if (Array.isArray(variableList) && variableList.length > 0) {
        variableList.forEach(variable => {
          if (!variable.builtin) {
            let column = this.columnMap.get(variable.bindColumnId);
            let relation = this.relationMap.get(variable.bindRelationId);
            if (column != null) {
              if (variableData == null) variableData = {};
              let key = relation == null ? '' : relation.variableName + '__';
              key += column.columnName;
              variableData[variable.variableName] = this.formData[key];
            }
          }
        });
      }
      return variableData;
    },
    getFormData () {
      if (this.formId2 === '2074057795207958528') {
        if (this.formData.project_id && this.formData.is_supplementary_agreement && !this.formData.contract_id){
          this.$message.error('请先选择合同！');
          return;
        }
      }
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (!valid) return reject();
          let tempObj = {};
          let that = this;
          let oneToOneRelationObj = {};
          let hasMasterData = false;
          function getFlowWidgetData (widget) {
            if (widget == null || widget.readOnly || widget.disabled) return;
            if (widget.relation != null) {
              if (tempObj.slaveData == null) tempObj.slaveData = {};
              if (widget.widgetType === that.SysCustomWidgetType.Table) {
                let tableData = that.getRelationTableData(widget);
                if (tableData != null) {
                  tempObj.slaveData[widget.relation.relationId] = tableData;
                }
              } else {
                oneToOneRelationObj[widget.relation.relationId] = widget.relation;
              }
            } else {
              hasMasterData = true;
            }

            if (Array.isArray(widget.childWidgetList)) {
              widget.childWidgetList.forEach(subWidget => {
                getFlowWidgetData(subWidget);
              });
            }
          }

          // 一对多关联数据
          if (Array.isArray(this.formConfig.formWidgetList)) {
            this.formConfig.formWidgetList.forEach(widget => {
              getFlowWidgetData(widget);
            });
          }
          // 主表数据
          if (hasMasterData && this.masterTable) {
            this.masterTable.columnList.forEach(column => {
              if (tempObj.masterData == null) tempObj.masterData = {};
              tempObj.masterData[column.columnName] = this.formData[column.columnName];
            });
          }
          // 一对一关联数据
          Object.keys(oneToOneRelationObj).forEach(relationId => {
            let relation = oneToOneRelationObj[relationId];
            if (relation && relation.slaveTable && Array.isArray(relation.slaveTable.columnList)) {
              relation.slaveTable.columnList.forEach(column => {
                let value = that.formData[relation.variableName + '__' + (column || {}).columnName];
                if (tempObj.slaveData[relationId] == null) tempObj.slaveData[relationId] = {};
                tempObj.slaveData[relationId][column.columnName] = value;
              });
            }
          });
          resolve(tempObj);
        });
      });
    },
    changeProject(val1, val2, val3, type) {
      let obj = val3
      if(type === 'contract'){
        this.formData.data_252 = obj.contract_name
        this.formData.data_265 = obj.sum_contract_amount
        this.formData.data_257 = obj.supplier_name
        this.formData.data_221 = obj.bank_name 
        this.formData.data_267 = obj.bank_account 
        this.formData.data_273 = obj.contract_no
        this.formData.data_286 = obj.contract_type
        this.formData.final_settlement_amount = obj.final_settlement_amount
        
        Contract.getProjectAmount(this, {
          projectName :this.formData.data_233,
          htName:this.formData.data_252
        }).then(res => {
          this.formData.data_253 = res.data.applyForAmount
        })
      }
      if(type === 'money' && this.$route.query.flowStatus !== '已办结'){
        if(!this.formData.data_233 || !this.formData.data_252) {
          this.formData.data_253 = 0
          return
        }
        Contract.getProjectAmount(this, {
          projectName :this.formData.data_233,
          htName:this.formData.data_252
        }).then(res => {
          this.formData.data_253 = res.data.applyForAmount
        })
      }
      if(type === 'project'){
        console.log(obj);
        
        this.formData.data_233 = obj.project_name
        this.formData.data_234 = obj.project_scale
        this.formData.data_235 = obj.project_nature
        this.formData.data_236 = obj.contract_start_date
        this.formData.data_237 = obj.actual_start_date
        this.formData.data_238 = obj.project_leader
        this.formData.project_nature = obj.project_nature
        this.formData.data_239 = obj.contract_end_date
        this.formData.data_240 = obj.actual_end_date
        this.formData.data_241 = obj.construction_unit
        this.formData.data_242 = obj.supervisor_unit
        //  清空合同信息
        this.formData.data_252 = null
        this.formData.data_265 = null
        this.formData.data_257 = null
        this.formData.data_221 = null
        this.formData.data_273 = null
        Contract.getProjectAmount(this, {
          projectName :this.formData.data_233,
          htName:this.formData.data_252
        }).then(res => {
          this.formData.data_253 = res.data.applyForAmount
          this.formData.data_287 = res.data.settlementAmount
        })
      }
      if (type === 'start' || type === 'end') {
        if (this.formData.start_time && this.formData.end_time && type !== 'xj') {
          Ask.askRecord(this, {
            endTime:this.formData.end_time + ':00',
            startTime: this.formData.start_time + ':00',
            userId: this.getUserInfo.userId,
            serialNo:this.formData.data_43
          }).then(res => {
            if (res.data) {
              this.formData.start_time = ''
              this.formData.end_time = ''
              this.$message({
                message: '当前选择时间已存在请假申请！',
                type: 'warning'
              });
            } else {
               Contract.getQJdays(this, {
                 endTime:this.formData.end_time + ':00',
                 startTime:this.formData.start_time + ':00'
               }).then(res => {
                 this.formData.duration = res.data
               })
            }
          })
        }
        if (this.formData.xj_start_time && this.formData.xj_end_time) {
          Contract.getQJdays(this, {
            endTime:this.formData.xj_end_time + ':00',
            startTime:this.formData.xj_start_time + ':00'
          }).then(res => {
            this.formData.xj_duration = res.data
          })
        }
      }
 
      if (type === 'xj') {
        let key = ''
        for (const k in this.formData) {
          if (k.split('__').length === 2) {
            key = k.split('__')[0]
            break
          }
        }
        this.formData['qj_id'] = obj.id
        this.formData[key + '__holiday_type'] = obj.holiday_type
        this.formData[key + '__end_time'] = obj.end_time
        this.formData[key + '__start_time'] = obj.start_time
        this.formData[key + '__duration'] = obj.duration
        this.formData[key + '__reason'] = obj.reason 
        this.formData['xj_end_time'] = obj.start_time 
        this.formData['xj_start_time'] = obj.start_time
        this.formData.xj_duration = 0
      }
      if(type === 'replace_time'){
        FlowOperationController.isBK(this,{date:val1.split(' ')[0]}).then(res => {
          if(!res.data){ 
            this.formData['replace_time'] = ''
            this.$notify.info({
              title: '提示',
              message: '当前选择时间暂无可提交的补卡申请!'
            });
            return
          }
        })
      }
    },
    getDiffDay(date_1, date_2){
       let myDate_1 = Date.parse(date_1)
      let myDate_2 = Date.parse(date_2)
      if (myDate_1 > myDate_2) {
        this.formData.start_time = ''
        this.formData.end_time = ''
        return
      }
      let startDate = new Date(date_1)
      let endDate = new Date(date_2)
      var base = 1000 * 60 * 60 * 24;
      var Days = 0;
      if (endDate.getTime() > 0 && startDate.getTime() > 0) {
          while (endDate.getTime() - startDate.getTime() >= 0) {
              if (startDate.getDay() != 6 && startDate.getDay() != 0) {
                  Days++;
              }
              startDate = new Date(startDate.getTime() + base);
          }
          return Days;
      } else {
          return ""
      }
    },
    getContract(project_name){
      this.formData.data_252 = null
      this.formData.data_265 = null
      this.formData.data_257 = null
      this.formData.data_221 = null
      this.formData.data_273 = null
      Contract.getContractList(this, {oaFormContractDto: {
        projectName: project_name,
      }}).then(rs => {
        this.contractList = rs.data.dataList.map(item => {
          const obj = {}
          for(var str in item){
             let newStr = str.split(/(?=[A-Z])/)
             newStr.map(name => name.toLowerCase())
             const key = newStr.map(name => name.toLowerCase()).join('_')
             obj[key] = item[str]
          }
          return obj
        })
      })
    },
    // 大写金额生成
    handleSetAmount(value, name) {
      this.formData[name] = this.chineseNumber(isNaN(value * 1) || value > 999999999999 ? 0 : value)
    },
    // 数字大小写转换
    chineseNumber(n) {
      var fraction = ["角", "分"];
      var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      var unit = [["元", "万", "亿"], ["", "拾", "佰", "仟"]];
      var head = n < 0 ? "负" : "";
      n = Math.abs(n);
      var s = "";
      const num = n.toString()
      if (num.split('.').length > 1) {
        let str = num.split('.')[1]
        for (let i = 0; i < fraction.length; i++) {
          if (str[i]) {
            s += digit[str[i]*1] + fraction[i]
          }
        }
      }else{
       s = s || "整";
      }
      n = Math.floor(n);
      for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = "";
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      // console.log(s);
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    }
  },
  computed: {
    formReadOnly () {
      return this.readOnly === 'true' || this.readOnly;
    }
  }
}

</script>

<style lang='scss' scope>
.my-row{
  display: flex;
  flex-wrap: wrap;
}
.fileList {
  position: relative;
  margin: 15px 8px;
}

.fileList::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 20px;
  background-color: rgb(64, 158, 255);
  position: absolute;
  left: -8px;
  top: 0px
}

.form-single-fragment {
  padding: 0 20px;

  .el-form-item__content {
    line-height: 25px;
  }
}

.text_title {
  text-align: center;
  margin: 30px 0;
}
</style>
